<template>
    <div class="area-container">
        <div class="area-tools">
            <el-tooltip class="box-item" effect="light" content="添加" placement="bottom">
                <el-button type="primary" plain size="small" :icon="Plus" style="width: 25px" @click="onAddClick"></el-button>
            </el-tooltip>
            <el-tooltip class="box-item" effect="light" content="编辑" placement="bottom">
                <el-button
                    type="success"
                    plain
                    size="small"
                    :disabled="!isEdit"
                    :icon="Edit"
                    @click="onEditClick"
                    style="width: 25px"
                ></el-button>
            </el-tooltip>
            <el-tooltip class="box-item" effect="light" content="导入" placement="bottom">
                <el-button
                    type="info"
                    plain
                    size="small"
                    :icon="Download"
                    style="width: 25px"
                    @click="uploadVisible = true"
                ></el-button>
            </el-tooltip>
            <el-tooltip class="box-item" effect="light" content="导出" placement="bottom">
                <el-button
                    type="warning"
                    plain
                    size="small"
                    :icon="Upload"
                    style="width: 25px"
                    @click="handleExport()"
                ></el-button>
            </el-tooltip>
            <el-tooltip class="box-item" effect="light" content="删除" placement="bottom">
                <el-button
                    type="danger"
                    plain
                    size="small"
                    :disabled="!isEdit"
                    :icon="Delete"
                    style="width: 25px"
                    @click="onRemoveClick"
                ></el-button>
                <!-- :disabled="!currentClickGroupId" -->
            </el-tooltip>
        </div>
        <ul class="unit-list">
            <li class="unit-item" @click="changeGroup('')" :class="{ active: !currentClickGroupId }">全部</li>
            <li
                class="unit-item"
                v-for="item in tableDate"
                :key="item.id"
                @click="changeGroup(item)"
                :class="{ active: item.id == currentClickGroupId }"
            >
                <span class="typeName">{{ item.name }}</span>
                <div class="presetIcon" v-if="item?.preset">预</div>
            </li>
        </ul>
        <AddEquiType v-model="formDialogVisible" :isForm="isForm" :equTypeId="equTypeId" @updateForm="getEquipTypelListFun" />
        <ImportsForm v-if="uploadVisible" v-model="uploadVisible" menuCode="equipType" @updateForm="getUploadStatus" />
    </div>
</template>

<script setup>
import { computed, defineEmits, onMounted, ref, watch } from 'vue'
import { Delete, Download, Edit, Plus, Upload } from '@element-plus/icons'
import { delEquipType, getEquipTypeOptionLists, getExportEquipTypeOptionLists } from '@/api/equipType.js' // patchEquipType
import AddEquiType from './AddEquiType.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import ImportsForm from '@/components/ImportsForm.vue'
import { getItem } from '@/utils/storage'
// 是否为系统管理员
const isSystemAdmin = computed(() => getItem('userInfo')?.is_system_admin)

const emits = defineEmits(['change', 'updateForm'])
const tableDate = ref([])
// 导入弹框
const uploadVisible = ref(false)
// 列表
const getEquipTypelListFun = async () => {
    const data = await getEquipTypeOptionLists()
    emits('updateForm')
    tableDate.value = data
    console.log(data)
}

// 获取导入弹框状态,上传成功后刷新
const getUploadStatus = (e) => {
    getEquipTypelListFun()
}

// 操作
const isForm = ref(false)
const equTypeId = ref('')
const formDialogVisible = ref(false)
const currentClickGroupId = ref('')
const currentClickGroupItem = ref({})
// 是否可编辑
const isEdit = ref(false)

// 切换列表项
const changeGroup = (item) => {
    console.log(item)
    if (item) {
        emits('change', item.id, item.code)
        currentClickGroupId.value = item.id
        currentClickGroupItem.value = item
        console.log('isSystemAdmin.value', isSystemAdmin.value)
        if (isSystemAdmin.value) {
            isEdit.value = true
        } else {
            isEdit.value = !item?.preset
        }
    } else {
        isEdit.value = false
        emits('change', item)
        currentClickGroupId.value = item
    }
}
// 添加
const onAddClick = () => {
    equTypeId.value = ''
    isForm.value = true
    formDialogVisible.value = true
}

// 编辑
const onEditClick = () => {
    equTypeId.value = currentClickGroupId.value
    isForm.value = true
    formDialogVisible.value = true
}

// 删除

const onRemoveClick = (row) => {
    ElMessageBox.confirm('确定要删除 ' + currentClickGroupItem.value.name + ' 吗？', {
        type: 'warning'
    })
        .then(async () => {
            await delEquipType(currentClickGroupId.value)
            ElMessage.success('删除成功！')
            // 重新渲染数据
            getEquipTypelListFun()
            emits('change', null)
            currentClickGroupId.value = null
        })
        .catch(() => {})
}

// 导出
const handleExport = async () => {
    ElMessageBox.confirm('您确定导出全部设备类型吗？', {
        type: 'warning'
    })
        .then(async () => {
            const { data } = await getExportEquipTypeOptionLists({ ...tableDate.value, export: 1 })
            window.open(data)
            ElMessage.success('导出成功')
        })
        .catch(() => {})
}

watch(formDialogVisible, (val) => {
    if (!val) equTypeId.value = ''
})

/**
 * 被 keep-alive 缓存的组件激活时调用
 */
onMounted(() => {
    getEquipTypelListFun()
})
</script>

<style lang="scss" scoped>
.unit-item {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .typeName {
        display: inline-block;
        width: 80%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .presetIcon {
        width: 18px;
        height: 18px;
        background-color: var(--theme-color);
        color: #fff;
        font-size: 12px;
        line-height: 18px;
        text-align: center;
        border-radius: 50%;
    }
}
</style>
